import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';

let inject = [
  '$scope',
  'DetailZoneService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'DetailedPaymentService',
  'SessionService',
  
];

class ConsultCrmController{
  // constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, AdvanceService) {
  constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, SessionService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.DetailedPaymentService = DetailedPaymentService;
    this.SessionService = SessionService;
    // this.AdvanceService = AdvanceService;
    this.$uibModal = $uibModal;
    this.DetailZoneService = DetailZoneService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.plant = [];
    this.concepts = [];
    this.advance = {};
    this.conceptSelected = null;
    this.openModal = false;
    this.conceptSelected = 2;
    this.payment = {};

 
  }

  $onInit(){
	  this.shCtrl.activate();
    this.tab = 1;

    this.shCtrl.globals.currentUser.activeTap = 0;
    this.getDatas();
    this.copy();

    //this.getBillfold();
  }
  
  getDatas() {
    if(angular.isUndefined(this.shCtrl.globals.currentUser.payCart)){
      this.dataGlobals = this.shCtrl.globals;
      this.dataGlobals.currentUser.payCart = [];
      this.dataGlobals.currentUser.totalCartPay = null;     
      this.SessionService.put('globals', this.dataGlobals);
    }

  }


  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
  copy(){
    angular.copy(this.shCtrl.globals.currentUser,this.shCtrl.globals.currentClient);
  }
}

ConsultCrmController.$inject = inject;

export default ConsultCrmController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/consult-crm.controller.js
 **/